import 'react-native-gesture-handler';
import { registerRootComponent } from 'expo';
import Root from './Root';

registerRootComponent(Root);